import TagClassificationsContract from 'decentralized/contracts/tagClassificationsContract.js';
import accounts from 'accounts/Accounts.js';
import {web3} from './web3.js';
import GuildTagClassificationsContract from 'decentralized/contracts/GuildTagClassificationsContract.js';
import {NewGuildClassification} from './EthereumEvents.js';
import BackendQuery from './BackendQuery.js';
import ipfs from 'decentralized/Ipfs.js';
import {ipfsHashToBytes32} from 'decentralized/ethereumUtils.js';
import {bytes32ToIPFSHash} from 'decentralized/ethereumUtils.js';

const contract = new GuildTagClassificationsContract();
const CACHE = {};

class TagClassifications {
    constructor() {
        if (web3  === undefined) {
            return;
        }
        if (web3.eth.net.isListening()) {
            this.contract = new web3.eth.Contract(contract.abi, contract.contractAddress);
            this.ethAddress = this.contract.options.address;
        }
    }

    saveClassifications(guildId, classifications) {
        return new Promise(async (resolve, reject) => {
            let hash = await ipfs.addJson(classifications);
            // then sends the hash to ethereum
            this.contract.methods.newGuildClassification(guildId, ipfsHashToBytes32(hash))
                .send({
                    from: await accounts.getAccount()
                }, (error, transactionHash) => {
                    if (error) {
                        reject(error);
                    } else {
                        resolve(hash);
                    }
                });
        });
    }

    async getClassificationsHash(guildId=0) {
        let query = new BackendQuery(contract.contractAddress)
            .from(NewGuildClassification)
            .select('contentHash')
            .where('guildId', guildId);

        let results = await query.executeQuery();

        if (results.length === 0) {
            return undefined;
        }
        return results[0].contentHash;
    }

    getClassifications(guildId=0) {
        return new Promise(async (resolve, reject) => {
            return;
            if (CACHE[guildId]) {
                return resolve(CACHE[guildId]);
            }
            let hash = await this.getClassificationsHash(guildId);
            if (hash === undefined) {
                resolve({});
            } else {
                let json = await ipfs.getJson(hash);
                CACHE[guildId] = json;
                resolve(json);
            }
        });
    }
}

export default TagClassifications;
